// @ts-nocheck

import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { setExperiencesCategory } from 'store/experiences/actions';
import {
  getExperiencesCategory,
  getExperiencesSlowLoading,
} from 'store/experiences/selectors';
import { getSettings, getStays } from 'store/stays/selectors';
import { getExperienceCategories } from '../../store/experiences/experience_utils';
import styled, { keyframes } from 'styled-components';
import { categoryRegistry } from 'utils/index';

const Root = styled.div`
  display: flex;
  margin-bottom: 20px;
  /* justify-content: center; */
  flex-wrap: wrap;
  margin-top: -10px;
`;
const slideIn = keyframes`
  0% { transform: translateX(300px); opacity: 0; }
  100% { transform: translateX(0px); opacity: 1; }
`;

const ScrollWrapper = styled.div`
  display: flex;
  gap: 0;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none;
  margin-left: -4px;
`;

const Button = styled.div`
  background: ${(props) => (props.selected ? props.button_color : 'white')};
  color: ${(props) => (props.selected ? props.button_text_color : 'black')};
  font-weight: ${(props) => props.selected};
  font-size: small;
  /* box-shadow: ${(props) =>
    props.selected &&
    'rgba(0, 0, 0, 0.2) 0px 5px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset'}; */
  cursor: pointer;
  padding: 5px 12px;
  border-radius: 10px;
  margin: 0px 5px;
  margin-top: 10px;
`;

const Categories = ({ experiences }: any) => {
  const scrollRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { campaignTag, locationTag, category } = useParams(); // 👈 Get category from route param
  const selected = useSelector(getExperiencesCategory);
  const settings = useSelector(getSettings);
  const stayLocation = useSelector(getStays);
  const categories = getExperienceCategories(experiences);
  const slowLoading = useSelector(getExperiencesSlowLoading);

  useEffect(() => {
    const matchedCategory = categories.find(
      (cat) => cat.toLowerCase() === category?.toLowerCase()
    );

    if (matchedCategory) {
      dispatch(setExperiencesCategory(matchedCategory));
    }
  }, [category, dispatch]);

  useEffect(() => {
    if (!slowLoading && selected) {
      dispatch(setExperiencesCategory(selected));
    }
  }, [slowLoading, selected, dispatch]);

  const handleSelectCategory = (newCategory) => {
    dispatch(setExperiencesCategory(newCategory));
    if (locationTag) {
      navigate(`/${locationTag}/concierge/${newCategory}`, { replace: true });
    }
    if (campaignTag) {
      navigate(`/${campaignTag}/demo`, { replace: true });
    }
  };
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const timer = setTimeout(() => {
      const maxScroll = container.scrollWidth - container.clientWidth;

      if (maxScroll > 0) {
        // Step 1: smooth scroll RIGHT
        container.scrollTo({
          left: maxScroll, // not full extreme, looks more natural
          behavior: 'smooth',
        });

        // Step 2: wait, then scroll LEFT smoothly
        setTimeout(() => {
          container.scrollTo({
            left: 0,
            behavior: 'smooth',
          });
        }, 900); // adjust this delay to match speed of scroll
      }
    }, 2000); // wait 3 seconds before starting

    return () => clearTimeout(timer);
  }, []);

  return (
    <Root className="categories-container">
      <div
        style={{
          display: 'flex',
          gap: 0,
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          scrollbarWidth: 'none',
          marginLeft: '-4px',
        }}
      >
        <ScrollWrapper ref={scrollRef}>
          {categories
            .filter((cat) => cat !== 'Hotel Info')
            .map((cat, i) => {
              const isSelected = cat === selected;
              const { label, icon } =
                categoryRegistry[cat] || categoryRegistry.All;

              return (
                <Button
                  key={i}
                  onClick={() => handleSelectCategory(cat)}
                  selected={isSelected}
                  button_color={settings.button_color}
                  button_text_color={settings.button_text_color}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '70px',
                    minWidth: '90px',
                    flexShrink: 0,
                    animationDelay: `${i * 50}ms`,
                  }}
                >
                  {icon && (
                    <div
                      style={{
                        width: '30px',
                        height: '30px',
                        margin: '2px',
                        borderRadius: '8px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        background: isSelected
                          ? 'rgba(0, 0, 0, 0.6)'
                          : '#F4F4F4',
                      }}
                    >
                      <img
                        src={icon}
                        alt={label}
                        style={{
                          width: '25px',
                          height: '20px',
                          filter: isSelected
                            ? 'brightness(0) invert(1)'
                            : 'none',
                        }}
                      />
                    </div>
                  )}
                  {!categoryRegistry[cat] && cat}
                  {categoryRegistry[cat] && label}
                </Button>
              );
            })}
        </ScrollWrapper>
      </div>
    </Root>
  );
};

export default Categories;
